import { render, staticRenderFns } from "./ClinicalPlacementsDashboard.vue?vue&type=template&id=63a212da&scoped=true"
import script from "./ClinicalPlacementsDashboard.vue?vue&type=script&lang=js"
export * from "./ClinicalPlacementsDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a212da",
  null
  
)

export default component.exports